export default __webpack_public_path__ + "static/media/search.0f90a7fb.svg";